import { render, staticRenderFns } from "./StepSelector.vue?vue&type=template&id=80570174&scoped=true&"
import script from "./StepSelector.vue?vue&type=script&lang=js&"
export * from "./StepSelector.vue?vue&type=script&lang=js&"
import style0 from "./StepSelector.vue?vue&type=style&index=0&id=80570174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80570174",
  null
  
)

export default component.exports